import { API_ENDPOINTS } from "@features/tickets/config/constants";
import type { TicketAttachment } from "@features/tickets/types/ticket.types";
import api from "@lib/api/client";
import { queryKeys } from "@lib/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useTicketAttachments(ticketId: number | string) {
  return useQuery({
    queryKey: queryKeys.tickets.attachments.all(ticketId),
    queryFn: async () => {
      const response = await api.get<TicketAttachment[]>(
        API_ENDPOINTS.TICKETS.ATTACHMENTS(ticketId),
      );
      return response.data;
    },
    enabled: !!ticketId,
  });
}
